import React from "react";
import { Checkbox, Avatar, Typography } from "@mui/material";
import styles from "../insuranceStatement.module.css";

const CheckboxIcon = ({ checked, indeterminate }) => (
  <svg width="13" height="13" viewBox="0 0 13 13" style={{ display: "block" }}>
    <rect x="0.5" y="0.5" width="12" height="12" rx="2" fill="transparent" stroke="#197f8f" />
    {checked && (
      <path
        d="M3 6.6L5.4 9L10 3.8"
        fill="none"
        stroke="#197f8f"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
    {indeterminate && <rect x="3" y="5.75" width="7" height="1.5" fill="#197f8f" />}
  </svg>
);

const checkboxSx = {
  padding: 0,
};

const checkboxAbsoluteSx = {
  ...checkboxSx,
  position: "absolute",
  left: 23,
  top: "50%",
  transform: "translateY(-50%)",
};

export default function PatientsStep({ patients = [], selected, onToggle, onToggleAll }) {
  const allChecked = selected.size === patients.length;
  const indeterminate = selected.size > 0 && !allChecked;

  const toggleAll = () => onToggleAll();
  const toggleOne = (id) => onToggle(id);

  return (
    <div className={styles.stepContainer}>
      {/* Summary bar */}
      <div className={styles.summaryBar}>
        <Typography className={styles.textBold}>Select Patients</Typography>
        <Typography className={styles.textLight}>
          {selected.size} of {patients.length} eligible patients will be
          included to generate statement.
        </Typography>
      </div>

      {/* Patient table */}
      <div className={styles.tableContainer}>
        {/* Header */}
        <div className={styles.tableHeader}>
          <div
            className={styles.tableHeaderCheckboxArea}
            onClick={toggleAll}
          >
            <Checkbox
              checked={allChecked}
              indeterminate={indeterminate}
              onChange={toggleAll}
              onClick={(e) => e.stopPropagation()}
              icon={<CheckboxIcon />}
              checkedIcon={<CheckboxIcon checked />}
              indeterminateIcon={<CheckboxIcon indeterminate />}
              size="small"
              sx={checkboxSx}
            />
            <Typography className={styles.tableCellText}>{selected.size}</Typography>
          </div>

          <Typography className={styles.tableHeaderCell} style={{ left: 105 }}>
            Username
          </Typography>
          <Typography className={styles.tableHeaderCell} style={{ left: 432 }}>
            Compliance
          </Typography>
          <Typography className={styles.tableHeaderCell} style={{ left: 615 }}>
            Day Used
          </Typography>
        </div>

        {/* Body */}
        <div className={styles.tableBody}>
          {patients.map((patient) => (
            <div
              key={patient.id}
              className={`${styles.tableRow} ${selected.has(patient.id) ? styles.tableRowSelected : ""}`}
            >
              <Checkbox
                checked={selected.has(patient.id)}
                onChange={() => toggleOne(patient.id)}
                icon={<CheckboxIcon />}
                checkedIcon={<CheckboxIcon checked />}
                size="small"
                sx={checkboxAbsoluteSx}
              />

              <div className={styles.tableRowAvatarArea}>
                <Avatar
                  src={patient.avatarUrl || undefined}
                  style={{
                    width: 28,
                    height: 28,
                    fontSize: 12,
                    backgroundColor: "#197f8f",
                    fontFamily: "Poppins",
                  }}
                >
                  {patient.name?.charAt(0)}
                </Avatar>
                <Typography className={styles.tableCellName}>
                  {patient.name}
                </Typography>
              </div>

              <Typography
                className={`${styles.tableAbsoluteCell} ${styles.tableCellTeal}`}
                style={{ left: 432 }}
              >
                Eligible
              </Typography>
              <Typography
                className={`${styles.tableAbsoluteCell} ${styles.tableCellTeal}`}
                style={{ left: 615 }}
              >
                {patient.daysUsed}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
